import dayjs from 'dayjs'
import * as locale from 'dayjs/locale/fr'
import { reactive } from '@vue/composition-api'
import pluralize from '@iez/lib/pluralize/'

const state = reactive({
  now: dayjs()
})

export default {
  getTimeAgo: ({ datetime, simplify }) => {
    const today = dayjs(state.now)
    const other = dayjs(datetime)
    const diffBuilder = ({ label, unit }) => {
      const diff = today.diff(other, unit)
      if (diff > 0) {
        return label
          ? simplify
            ? `${diff}${label[0]}`
            : `il y a ${pluralize({ word: label, count: diff })}`
          : other.format('DD MMMM')
      }
    }
    return diffBuilder({ unit: 'year' })
      || diffBuilder({ unit: 'month' })
      || diffBuilder({ unit: 'week' })
      || diffBuilder({ label: 'jour', unit: 'day' })
      || diffBuilder({ label: 'heure', unit: 'hour' })
      || diffBuilder({ label: 'minute', unit: 'minute' })
      || (simplify ? '<1m' : `à l'instant`)
  },

  setup: () => {
    dayjs.locale(locale)
    setInterval(
      () => {
        state.now = dayjs()
      },
      1000
    )
  }
}
